import * as React from 'react';
import { Link } from 'react-router';

import BreadcrumbItem from '../../../api/breadcrumbItem';

interface IProps {
    breadcrumbItem: {breadcrumbItems: BreadcrumbItem[], latestPageTitle: string, nextRouteLocationPathname: string}
}

export class Breadcrumb extends React.Component<IProps,{}> {
  public render() {
    return (
        <div className="breadcrumb">
            {this.props.breadcrumbItem.breadcrumbItems.map(BreadcrumbRow)}
            <span>{this.props.breadcrumbItem.latestPageTitle}</span>
        </div>
    );
  }
};

const BreadcrumbRow = (breadcrumbItem: BreadcrumbItem) => {
    return (
        <React.Fragment>
            <Link to={`${breadcrumbItem.navigationUrl}`}>{breadcrumbItem.title}</Link>
        </React.Fragment>
    )
  }


// WEBPACK FOOTER //
// ./src/common/components/breadcrumb/breadcrumb.tsx